import React from 'react';
import { format } from 'date-fns';
import { AUIButtonCell } from '@ancert/aui-table-cell';
import AUIEllipsis from '@ancert/aui-ellipsis';

import { ESTADOS_DENUNCIA } from '../../../../../lib/denuncia.enum';

const getColumns = (onDesasignar, canViewId) => [
  {
    id: 'id',
    accessor: (row) => row.complaint,
    columnWidth: canViewId ? 80 : 280,
    header: 'ID',
    cell: ({ value }) => <>{canViewId ? value.id : value.publicId}</>,
  },
  {
    id: 'denunciante',
    accessor: (row) => row.user.name,
    header: 'Denunciante',
    cell: ({ value }) => <>{!value ? 'Anónimo' : value}</>,
  },
  {
    id: 'email',
    accessor: (row) => row.user.email,
    columnWidth: 230,
    header: 'Correo electrónico',
    cell: ({ value }) => <>{!value ? '' : value}</>,
  },
  {
    id: 'documentType',
    accessor: (row) => row.user.documentType,
    columnWidth: 120,
    header: 'Tipo documento',
    cell: ({ value }) => <AUIEllipsis content={value}/>,
  },
  {
    id: 'dni',
    accessor: (row) => row.user.document,
    columnWidth: 100,
    header: 'Doc. identidad',
    cell: ({ value }) => <AUIEllipsis content={value}/>,
  },
  {
    id: 'fecha',
    accessor: (row) => row.complaint.creationDate,
    header: 'Fecha',
    columnWidth: 96,
    cell: ({ value }) => <>{format(new Date(value), 'dd/MM/yyyy')}</>,
  },
  {
    id: 'status',
    accessor: (row) => row.complaint.status,
    header: 'Estado',
    columnWidth: 96,
    cell: ({ value }) => <>{ESTADOS_DENUNCIA[value].desc}</>,
  },
  {
    id: 'action',
    accessor: (row) => row,
    header: '',
    columnWidth: 80,
    cell: ({ value }) => (
      <AUIButtonCell
        buttonList={[
          {
            mode: 'ghost',
            label: 'Desasignar',
            onClick: () => {
              onDesasignar(value);
            },
          },
        ]}
      />
    ),
  },
];

export default getColumns;
